import apiService from '@/services/api';

class SuperAdminsService {
  revokeCurrentChurchAdminAccess = async (): Promise<void> => {
    await apiService.delete('/super-admins/current/church-admin-access');
  };
}

export default new SuperAdminsService();
